module.exports = __webpack_public_path__ + "static/media/oberflex-noyergrispoudre-1200x2490.97f9bda6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-noyergrispoudre-1200x2490.jpg
// module id = 1044
// module chunks = 37